import Card from './Card';
import DoubleCard from './DoubleCard';
import Wrapper from './Wrapper';
import ProductCard from './ProductCard';
import MediaCard from './MediaCard';
import MediaCardGrid from './MediaCardGrid';
import SmallCard from './SmallCard';
import SmallWrapper from './SmallWrapper';
export default {
  Card,
  DoubleCard,
  Wrapper,
  ProductCard,
  MediaCard,
  MediaCardGrid,
  SmallCard,
  SmallWrapper,
};
